import { gsap } from 'gsap'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'
import { CSSPlugin } from 'gsap/CSSPlugin' // eslint-disable-line

gsap.registerPlugin(ScrollToPlugin)
